export default __webpack_public_path__ + "758ff6a39c8b5b57c9c6ff072db5a908.svg";